module.exports = __webpack_public_path__ + "static/media/CHAP01-BURSASPOR-LOGO.f80cf092.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/CHAP01-BURSASPOR-LOGO.png
// module id = 249
// module chunks = 0